import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var section1 = new Swiper('.section1 .swiper', {
    slidesPerView: 2.39,
    spaceBetween: 53,
    loop:true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
    pagination: {
        el: ".section1 .swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
      },
	speed:800,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 2.39,
            spaceBetween: 53,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 2.39,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 10,
        }
    },
}); 

$(".section6 ul li").eq(0).addClass('active');
$(".section6 ul li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".text").slideToggle();
})